import { useEffect, useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { LayoutProps } from '~/rage/utils';

const useHudVisibilityTracker = (props: LayoutProps[]) => {
	const visibleLayouts = useObservable(rage.gui.getVisibleLayouts());

	const isHudVisible = useMemo(() => {
		return (
			props.filter(
				(e) =>
					!e.isHud && !e.hudVisible && visibleLayouts.includes(e.displayName!),
			).length === 0
		);
	}, [props, visibleLayouts]);

	useEffect(() => {
		rage.gui.setHudVisible(isHudVisible);
	}, [isHudVisible]);
};

export { useHudVisibilityTracker };
